import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from './styles/shared-styles';
import './common/bn-surface';
import './common/bn-loading';
import './common/bn-logo';

class BinsentrySplash extends LitElement {
  static get styles() {
    return [sharedStyles, css`
      bn-surface {
        max-width: 300px;
        margin: 20px auto;
        padding: 20px;
        border: 1px solid #ddd;
      }
      bn-logo {
        display: block;
      }
    `];
  }

  render() {
    return html`
      <bn-surface>
        <bn-logo></bn-logo>
        <bn-loading></bn-loading>
      </bn-surface>
    `;
  }
}

window.customElements.define('binsentry-splash', BinsentrySplash);
